<template>
  <div class="page-container">
    <div class="title-1-container">
      <img class="experience-img" :src="props.experienceIcon">
      <h2 class="title">{{ props.pageTitle }}</h2>
    </div>

    <div class="border">
      <div class="skill-container-coding" v-for="(text, index) in props.Experiences" :key="index">
        <img :src="require(`@/assets/about/${text.companyIcon}`)">
        <div class="role-name"> {{ text.role }}</div>

        <div class="division-line"></div>

        <span class="company-name"> {{ text.companyName }}</span>
        <span class="company-location-name"> {{ text.companyLocation }}</span>
        <span class="year-name"> {{ text.year }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  pageTitle: String,
  Experiences: Object,
  experienceIcon: Object
});

</script>

<style lang="scss" scoped>
.experience-img {
  align-self: center;
}

.page-container {
  margin-left: 14.2%;
  margin-right: 14.2%;
}

.title-1-container {
  display: flex;
}

.division-line {
  height: 2px;
  background-color: white;
  margin-left: 100px;
}

.title {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 46px;
  margin-left: 10px;
  /* Ajuste conforme necessário */
}

.title-2-container {
  display: flex;
  margin-bottom: 20px;
}

.title_2 {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 20px;
  margin-left: 10px;
  /* Ajuste conforme necessário */
  margin-top: 15px;
}

.border {
  border: 3px solid white;
  padding: 10px;
  margin-bottom: 50px;
  border-radius: 20px;
}

.role-name {
  font-family: 'Poppins-Regular';
  color: white;
  font-size: 30px;
  margin-top: -90px;
  margin-left: 100px;

}

.company-name {
  font-family: 'Poppins-Regular';
  color: white;
  font-size: 20px;
  margin-left: 100px;
}

.company-location-name {
  font-family: 'Poppins-Light';
  color: white;
  font-size: 15px;
  display: flex;
  margin-left: 100px;
}

.year-name {
  font-family: 'Poppins-Light';
  color: white;
  font-size: 15px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  margin-top: -25px;
}

.skill-container-coding {
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 10px;
}

@media(max-width: 1200px) {
  .border {
    padding: 10px;
  }

  .skill-container-coding {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 15px;
  }

  .page-container {
    margin-left: 8%;
    margin-right: 8%;
  }

  .title {
    font-size: 40px;
  }

  .company-name {
    display: flex;
  }

  .role-name {
    font-size: 27px;
  }

  .year-name {
    margin-top: 0px;
  }
}
</style>